import React from 'react';
import { NurtureSequence } from '@/types';
import { cn, formatPercentage, getSequenceTypeIcon } from '@/utils';

interface CampaignOverviewProps {
  sequences: NurtureSequence[];
}

export const CampaignOverview: React.FC<CampaignOverviewProps> = ({ sequences }) => {
  return (
    <div className="bg-slate-700 rounded-lg border border-slate-600 p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-slate-50">
          Active Nurture Campaigns
        </h2>
        <button className="text-sm text-slate-400 hover:text-white">
          ⚙️
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-slate-600">
              <th className="text-left text-sm font-medium text-slate-300 pb-3">
                Sequence Type
              </th>
              <th className="text-left text-sm font-medium text-slate-300 pb-3">
                Active
              </th>
              <th className="text-left text-sm font-medium text-slate-300 pb-3">
                Avg Score
              </th>
              <th className="text-left text-sm font-medium text-slate-300 pb-3">
                Conversion
              </th>
              <th className="text-left text-sm font-medium text-slate-300 pb-3">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {sequences.map((sequence, index) => (
              <tr 
                key={sequence.id}
                className={cn(
                  'border-b border-slate-600/50',
                  index % 2 === 0 ? 'bg-slate-700/50' : 'bg-slate-800/30'
                )}
              >
                <td className="py-3 pr-4">
                  <div className="flex items-center space-x-2">
                    <span role="img" aria-hidden="true">
                      {getSequenceTypeIcon(sequence.type)}
                    </span>
                    <span className="text-sm font-medium text-slate-200">
                      {sequence.name}
                    </span>
                  </div>
                </td>
                <td className="py-3 pr-4">
                  <span className="text-sm text-slate-300">
                    {sequence.performance.activeLeads.toLocaleString()}
                  </span>
                </td>
                <td className="py-3 pr-4">
                  <span className="text-sm text-slate-300">
                    {sequence.performance.avgEngagementScore.toFixed(1)}
                  </span>
                </td>
                <td className="py-3 pr-4">
                  <span className="text-sm text-slate-300">
                    {formatPercentage(sequence.performance.conversionRate)}
                  </span>
                </td>
                <td className="py-3">
                  <button className="text-sm text-blue-400 hover:text-blue-300">
                    [View]
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-t border-slate-600">
              <td className="pt-3 pr-4">
                <span className="text-sm font-medium text-slate-300">
                  Total Active Touches
                </span>
              </td>
              <td className="pt-3 pr-4">
                <span className="text-sm font-bold text-slate-200">
                  1,520
                </span>
              </td>
              <td className="pt-3 pr-4" />
              <td className="pt-3 pr-4" />
              <td className="pt-3" />
            </tr>
            <tr>
              <td className="pr-4">
                <span className="text-sm font-medium text-slate-300">
                  Today's Sends
                </span>
              </td>
              <td className="pr-4">
                <span className="text-sm font-bold text-slate-200">
                  342
                </span>
              </td>
              <td className="pr-4" />
              <td className="pr-4" />
              <td />
            </tr>
            <tr>
              <td className="pr-4">
                <span className="text-sm font-medium text-slate-300">
                  Failed Deliveries
                </span>
              </td>
              <td className="pr-4">
                <span className="text-sm font-bold text-red-400">
                  7
                </span>
              </td>
              <td className="pr-4" />
              <td className="pr-4" />
              <td />
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};